import { render, staticRenderFns } from "./ProjectStatisticsWidget.vue?vue&type=template&id=350b9e2c&scoped=true"
import script from "./ProjectStatisticsWidget.vue?vue&type=script&lang=js"
export * from "./ProjectStatisticsWidget.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatisticsWidget.vue?vue&type=style&index=0&id=350b9e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b9e2c",
  null
  
)

export default component.exports